import { AutoAwesomeRounded } from "@mui/icons-material";
import { CircularProgress, Paper, Stack, Typography } from "@mui/material";
import { useAiEventStreamSnapshot } from "../../hooks/useAiEventStream";
import { AiEventStreamSnapshot } from "../../types/AiEventStream";
import { useAiChat } from "../../provider/AiChatProvider";

export default function AiThinkingBubble() {
  const { activeAgent, activeThreadId } = useAiChat();
  const snapshot = useAiEventStreamSnapshot(activeThreadId);

  const getProgressText = (snapshot: AiEventStreamSnapshot) => {
    if (snapshot.graphNode.nodeName) {
      let baseText = "";
      if (snapshot.graphNode.graphName) {
        baseText = snapshot.graphNode.graphName + ": ";
      }
      baseText += snapshot.graphNode.nodeName;
      if (snapshot.graphNode.previousNodeName) {
        baseText += `, vorher: ${snapshot.graphNode.previousNodeName}`;
      }
      return baseText;
    } else {
      return snapshot.info || "Antwort wird vorbereitet...";
    }
  };

  return (
    <Paper variant={"outlined"} sx={{ p: "1rem", maxWidth: "85%" }}>
      <Stack
        direction={"row"}
        spacing={1}
        sx={{
          alignItems: "center",
        }}
      >
        <AutoAwesomeRounded color={"primary"} fontSize={"small"} />
        <CircularProgress size={14} />
        <Typography variant={"body2"} color={"text.secondary"}>
          {activeAgent} denkt nach...
        </Typography>
      </Stack>
      <Typography variant={"body2"} sx={{ color: snapshot.error ? "error.main" : "text.secondary" }}>
        {snapshot.error || getProgressText(snapshot)}
      </Typography>
    </Paper>
  );
}
